module.exports = __webpack_public_path__ + "img/d10sj-btn.254422d8.png";